import React from "react";
import { Box, Grid, Skeleton, Text } from "@mantine/core";
import useStyles from "./style";

const PaymentAnalytics = ({ data, loading }) => {
  const { classes } = useStyles();


  //  console.log('datahere',data);

  let totalAmount=data?.analytics?.analytics?.totalAmount;
  let pastDue=data?.analytics?.analytics?.pastDue;
  let upcomingProcessFees=data?.analytics?.analytics?.upcomingProcessFees;

 

  const getNextPaymentDate = () => {
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth(); 
    const year = today.getFullYear();
  
    let nextDay, nextMonth, nextYear;
  
    if (day < 1) {
      nextDay = 1;
      nextMonth = month;
      nextYear = year;
    } else if (day < 15) {
      nextDay = 15;
      nextMonth = month;
      nextYear = year;
    } else {
      nextDay = 1;
      nextMonth = (month + 1) % 12;
      nextYear = month === 11 ? year + 1 : year;
    }
  
    const nextDate = new Date(nextYear, nextMonth, nextDay);
    return nextDate.toLocaleDateString('default', { year: 'numeric', month: 'long', day: 'numeric' });
  };
  

  return (
    <>
      <Box className={classes.parentBox}>
        <Box className={classes.childBox}>
          <Box className={classes.grandChild}>
            <Text className={classes.billingText}>
              {/* <strong>Upcoming Billing Period:</strong> February, 2025 */}
              <strong>Next Payment Date:</strong> {getNextPaymentDate()}

            </Text>
            <Grid className={classes.gridStyling}>
              <Grid.Col
                className={classes.gridBorder}
                xs={12}
                sm={6}
                md={6}
                lg={4}
                xl={4}
              >
                <small className={classes.label}>Total Claims Paid </small>
                {loading ? (
                  <Skeleton visible={loading} height={35} width={35} />
                ) : (
                  <Box className={classes.numbersStyling} c={"#00A991"}>
                    ${totalAmount?.toFixed(2) || 0}
                  </Box>
                )}
              </Grid.Col>
              <Grid.Col
                className={`${classes.specialGridBorder} ${classes.gridPaddingLeft}`}
                xs={12}
                sm={6}
                md={6}
                lg={4}
                xl={4}
              >
                <small className={classes.label}>Past Due</small>
                {loading ? (
                  <Skeleton visible={loading} height={35} width={35} />
                ) : (
                  <Box className={classes.numbersStyling} c={"#D92D20"}>
                    ${pastDue?.toFixed(2) || 0}
                  </Box>
                )}
              </Grid.Col>
              <Grid.Col
                className={`${classes.gridPaddingLeft}`}
                xs={12}
                sm={6}
                md={6}
                lg={4}
                xl={4}
              >
                <small className={classes.label}>Upcoming Processing Fee</small>
                {loading ? (
                  <Skeleton visible={loading} height={35} width={35} />
                ) : (
                  <Box className={classes.numbersStyling}>
                    ${upcomingProcessFees?.toFixed(2) || 0}
                  </Box>
                )}
              </Grid.Col>
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default PaymentAnalytics;
